import { render, staticRenderFns } from "./TasksBoardFiltersSideBar.vue?vue&type=template&id=79ae6788&"
import script from "./TasksBoardFiltersSideBar.vue?vue&type=script&lang=js&"
export * from "./TasksBoardFiltersSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports